import { useQuery } from "@apollo/client/react";
import { Stack } from "@mui/material";
import { ContentSkeleton } from "../lib/closet";
import Screen from "../lib/Screen";
import { GetSystemSatisfactionReportDocument } from "./reports/GetSystemSatisfactionReport.generated.ts";
import SystemSatisfactionCharts from "./reports/SystemSatisfactionCharts.tsx";

export default function CallRatingsReportScreen() {
  const { data, error } = useQuery(GetSystemSatisfactionReportDocument, {
    fetchPolicy: "cache-and-network",
  });

  if (error) throw error;

  return (
    <Screen title="System satisfaction scores" maxWidth="md">
      <Stack spacing={2}>
        {!data && <ContentSkeleton />}
        {data && (
          <SystemSatisfactionCharts data={data.reports.systemSatisfaction} />
        )}
      </Stack>
    </Screen>
  );
}
